module.exports = __webpack_public_path__ + "img/logo.f37f38b0.png";